import { productLaunchEvents, productPageView } from "./constants/product";
import { pwaEvent, pwaEvents } from "./constants/pwa";
import { triggeredAction, triggeredActionEvents } from "./constants/triggered_action";

/**
 * Override Mixpanel requests and intercept data
 * @constructor
 */
function PMCMixpanel() {
    // region events
    this.productPageView = productPageView;
    this.productLaunchEvents = productLaunchEvents;

    this.pwaEvent = pwaEvent;
    this.pwaEvents = pwaEvents;

    this.triggeredAction = triggeredAction;
    this.triggeredActionEvents = triggeredActionEvents;
    // endregion events

    const eventTrackingIdKey = 'event_tracking_id';
    const mixpanelURL = 'api-js.mixpanel.com';
    const originalOpen = XMLHttpRequest.prototype.open;

    const url = location.origin + '/events/notify';

    /**
     * @type {boolean}
     */
    let isReady = false;

    /**
     * @type {string}
     */
    let token;

    /**
     * Override "open" function to intercept Mixpanel requests
     */
    const override = () => {
        try {
            token = getToken();

            isReady = true;
        } catch (e) {
            console.log(e);
            return
        }

        XMLHttpRequest.prototype.open = function(method, url) {
            console.log('Intercepted HTTP request: ' + method + ' ' + url);

            if (url.indexOf(mixpanelURL) >= 0) {
                console.log('Is Mixpanel request - aborting');

                this.abort()

                return
            }

            console.log('Is not Mixpanel request - original open called');

            originalOpen.apply(this, arguments);
        };
    };

    /**
     * Retrieve CSRF token
     * @return {string}
     * @throws {Error}
     */
    const getToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]').content;

        if (token === "") {
            throw new Error('CSRF token is empty')
        }

        return token;
    };

    const retry = (event, data) => {
        setTimeout(() => {
            this.track(event, data, true)
        }, 5000);
    };

    /**
     * Get data from Mixpanel and dispatch our own request
     * @param {string} event
     * @param {{}=} data
     * @param {boolean=} isRetry
     */
    this.track = (event, data, isRetry) => {
        if (!isReady && !isRetry) {
            // retry once after 5 seconds
            retry(event, data);

            return;
        }

        /**
         * @type {{event: string, properties: {}}}
         */
        const eventWithProperties = mixpanel.track(event, data)

        if (!eventWithProperties) {
            // retry once after 5 seconds
            if (!isRetry) {
                retry(event, data);

                return;
            }

            return
        }

        const formData = new FormData()
        formData.append('_token', token);
        formData.append('event', event);
        formData.append('properties', JSON.stringify(eventWithProperties.properties));

        const urlData = new URL(location.href);

        if (urlData.searchParams.has(eventTrackingIdKey)) {
            formData.append(eventTrackingIdKey, urlData.searchParams.get(eventTrackingIdKey));
        }

        navigator.sendBeacon(url, formData)
    };

    // call override once the object is ready
    override();
}

window.PMCMixpanel = new PMCMixpanel();
